/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React, { FC, useState, ReactNode } from 'react';
import {
  Loading,
  IButtonProps,
  Icons,
} from '@sede-enterprise/shell-ds-react-framework';
import dayjs from 'dayjs';
import { ShellButton } from './style';
import { GenesisApi } from '../../services/GenesisApi';
import { sendNotification } from '../Notification';
import { COMMON_MESSAGES } from '../../constants/Common';

interface IDownloadButton<T = unknown> {
  downloadURL: string;
  method: 'GET' | 'POST';
  body?: T;
  fileName: string;
  fileType: 'csv' | 'xlsx' | 'xml';
  buttonProp?: IButtonProps;
  children?: ReactNode | string;
  hideIcon?: boolean;
}

const { DownloadSolid } = Icons;

const DownloadButton: FC<IDownloadButton> = ({
  downloadURL,
  method,
  body,
  fileName,
  fileType,
  buttonProp,
  hideIcon = false,
  children,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleOnClick = () => {
    setLoading(true);
    GenesisApi({
      url: downloadURL,
      method,
      responseType: 'blob',
      data: body,
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `${fileName}_${dayjs().format('YYYY-MM-DDTHH.mm.ssZ')}.${fileType}`
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        sendNotification({
          type: 'error',
          message: COMMON_MESSAGES.ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ShellButton
      onClick={handleOnClick}
      icon={hideIcon ? null : <DownloadSolid />}
      disabled={loading}
      data-testid='btn-download'
      {...buttonProp}
    >
      {loading && (
        <Loading
          type={buttonProp?.variant === 'filled' ? 'primary' : 'default'}
        />
      )}{' '}
      {children}
    </ShellButton>
  );
};

export default DownloadButton;
